import createHistory from 'history/createBrowserHistory';

const history = createHistory(); // Defaults to creating history type of browser history

export default history;



// WEBPACK FOOTER //
// ./src/redux/store/history.js